/*
 * BioIndex
 * Copyright (c) 2026 BioIndex™. All rights reserved.
 * Unauthorized copying, scraping, redistribution, or commercial reuse is prohibited.
 */

import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db, auth } from "../firebase";
import useScrollMemory from "../hooks/useScrollMemory";
import BioIndexExploreLevelLayout, {
  BioIndexTaxonCard,
} from "../components/BioIndexExploreLevelLayout";
import { useParams, useLocation } from "react-router-dom";
import { iconUrl, defaultImg } from "../utils/icons";
import { familiesByOrder } from "../utils/taxonomy";
import { generaByFamily } from "../utils/taxonomy";

function getFamilyImage(familyName) {
  const filename = familyImages[familyName];
  return filename ? iconUrl(filename) : defaultImg;
}
export const familyImages = {
  Nectriaceae: "Fusarium.png",
  Polygonaceae: "Coccoloba.png",
  Osteoglossidae: "Scleropages.png",
  Serrasalmidae: "Pygocentrus.png",
  Mobulidae: "Mobula.png",
  Ictaluridae: "Ictalurus.png",
  Scorpaenidae: "Pterois.png",
  Siganidae: "Siganus.png",
  Cyclopteridae: "Cyclopterus.png",
  Labridae: "Thalassoma.png",
  Pomacentridae: "Amphiprion.png",
  Priacanthidae: "Pristigenys.png",
  Lutjanidae: "Lutjanus.png",
  Chaetodontidae: "Chelmon.png",
  Ceratophryidae: "Ceratophrys.png",
  Carchariidae: "Carcharias.png",
  Ginglymostomatidae: "Ginglymostoma.png",
  Hemiscylliidae: "Chiloscyllium.png",
  Viburnaceae: "Sambucus.png",
  Giraffidae: "Giraffa.png",
  Lamnidae: "Carcharodon.png",
  Syngnathidae: "Syngnathus.png",
  Dasyatidae: "Hypanus.png",
  Aspleniaceae: "Asplenium.png",
  Amaryllidaceae: "Agapanthus.png",
  Doryanthaceae: "Furcraea.png",
  Leuciscidae: "Notropis.png",
  Geometridae: "Acronyctodes.png",
  Blattidae: "Validiblatta.png",
  Microbiotheriidae: "Dromiciops.png",
  Nothofagaceae: "Nothofagus.png",
  Loranthaceae: "Tristerix.png",
  Nemestrinidae: "Trichophthalma.png",
  Proteaceae: "Lomatia.png",
  Philesiaceae: "Lapageria.png",
  Hymenophyllaceae: "Hymenophyllum.png",
  Sargassaceae: "Sargassum.png",
  Ostraciidae: "Lactophrys.png",
  Escalloniaceae: "Escallonia.png",
  Curculionidae: "Gonipterus.png",
  Winteraceae: "Drimys.png",
  Melyridae: "Astylus.png",
  Batrachylidae: "Batrachyla.png",
  Blechnaceae: "Blechnum.png",
  Cunoniaceae: "Caldcluvia.png",
  Alsodidae: "Eupsophus.png",
  Centrarchidae: "Micropterus.png",
  Ulmaridae: "Aurelia.png",
  Muscicapidae: "Erithacus.png",
  Anhimidae: "Chauna.png",
  Elateridae: "Chalcolepidius.png",
  Hippopotamidae: "Hippopotamus.png",
  Chelidae: "Chelus.png",
  Begoniaceae: "Begonia.png",
  Ulmaceae: "Ulmus.png",
  Pyrrhocoridae: "Pyrrhocoris.png",
  Gryllotalpidae: "Gryllotalpa.png",
  Heterocephalidae: "Heterocephalus.png",
  Meloidae: "Epicauta.png",
  Betulaceae: "Betula.png",
  Nyctaginaceae: "Bougainvillea.png",
  Trechaleidae: "Trechalea.png",
  Boletaceae: "Suillus.png",
  Emballonuridae: "Saccopteryx.png",
  Pseudothelphusidae: "Phallangothelphusa.png",
  Mycenaceae: "Mycena.png",
  Parechinidae: "Paracentrotus.png",
  Mellitidae: "Mellita.png",
  Leptodactylidae: "Leptodactylus.png",
  Auriculariaceae: "Auricularia.png",
  Cimicidae: "Cimex.png",
  Ariolimacidae: "Ariolimax.png",
  Coenagrionidae: "Enallagma.png",
  Gaviidae: "Gavia.png",
  Ochnaceae: "Godoya.png",
  Symplocaceae: "Symplocos.png",
  Actinidiaceae: "Saurauia.png",
  Chloranthaceae: "Hedyosmum.png",
  Sabiaceae: "Meliosma.png",
  Pontederiaceae: "Pontederia.png",
  Equidae: "Equus.png",
  Sesarmidae: "Parasesarma.png",
  Pelecinidae: "Pelecinus.png",
  Psathyrellaceae: "Coprinellus.png",
  Marasmiaceae: "Hymeogloea.png",
  Amanitaceae: "Amanita.png",
  Suillaceae: "Suilus.png",
  Sclerodermataceae: "Calostoma.png",
  Hypocreaceae: "Hypomyces.png",
  Microteaceae: "Aphananthe.png",
  Caprifoliaceae: "Vesalea.png",
  Sarraceniaceae: "Sarracenia.png",
  Violaceae: "Rinorea.png",
  Rhizophoraceae: "Rhizophora.png",
  Hypericaceae: "Hypericum.png",
  Lacistemataceae: "Lacistema.png",
  Onagraceae: "Fuchsia.png",
  Scutelleridae: "Pachycoris.png",
  Ischnorhinidae: "Mahanarva.png",
  Balanophoraceae: "Helosis.png",
  Pisauridae: "Pisaurina.png",
  Lycosidae: "Arctosa.png",
  Dolomedidae: "Dolomedes.png",
  Dipluridae: "Linothele.png",
  Deinopidae: "Deinopis.png",
  Combretaceae: "Conocarpus.png",
  Tropaeolaceae: "Tropaeolum.png",
  Capparaceae: "Capparidastrum.png",
  Cannaceae: "Canna.png",
  Myristicaceae: "Virola.png",
  Annonaceae: "Annona.png",
  Notodontidae: "Americerura.png",
  Gesneriaceae: "Glossoloma.png",
  Lepismatidae: "Ctenolepisma.png",
  Plantaginaceae: "Aragoa.png",
  Orobanchaceae: "Castilleja.png",
  Clethraceae: "Clethra.png",
  Geraniaceae: "Geranium.png",
  Herbertaceae: "Herbertus.png",
  Dryopteridaceae: "Polystichum.png",
  Grimmiaceae: "Racomitrium.png",
  Lestidae: "Lestes.png",
  Membracidae: "Ennya.png",
  Balaenopteridae: "Megaptera.png",
  Acrididae: "Schistocerca.png",
  Spheniscidae: "Spheniscus.png",
  Primulaceae: "Parathesis.png",
  Ebenaceae: "Diospyros.png",
  Buxaceae: "Buxus.png",
  Cordiaceae: "Cordia.png",
  Ciconiidae: "Ciconia.png",
  Crassulaceae: "Crassula.png",
  Estrildidae: "Lonchura.png",
  Hydrangeaceae: "Hydrangea.png",
  Camelidae: "Lama.png",
  Chinchillidae: "Lagidium.png",
  Tetranychidae: "Bryobia.png",
  Motacillidae: "Motacilla.png",
  Coccinellidae: "Propylea.png",
  Helicidae: "Cornu.png",
  Arionidae: "Arion.png",
  Pimelodidae: "Pimelodus.png",
  Agelenidae: "Eratigena.png",
  Cacatuidae: "Cacatua.png",
  Accipitridae: "Spizaetus.png",
  Alcidae: "Cepphus.png",
  Burhinidae: "Burhinus.png",
  Anatidae: "Anas.png",
  Bucconidae: "Hypnelus.png",
  Capitonidae: "Eubucco.png",
  Caprimulgidae: "Chordeiles.png",
  Cathartidae: "Cathartes.png",
  Charadriidae: "Charadrius.png",
  Casuariidae: "Dromaius.png",
  Columbidae: "Patagioenas.png",
  Cuculidae: "Crotophaga.png",
  Eurypygidae: "Eurypyga.png",
  Galbulidae: "Galbula.png",
  Jacanidae: "Jacana.png",
  Laridae: "Larus.png",
  Pandionidae: "Pandion.png",
  Picidae: "Picoides.png",
  Ramphastidae: "Ramphastos.png",
  Semnornithidae: "Semnornis.png",
  Trochilidae: "Aglaiocercus.png",
  Haematopodidae: "Haematopus.png",
  Recurvirostridae: "Himantopus.png",
  Scolopacidae: "Arenaria.png",
  Sternidae: "Thalasseus.png",
  Alcedinidae: "Megaceryle.png",
  Momotidae: "Momotus.png",
  Dasyproctidae: "Dasyprocta.png",
  Iguanidae: "Iguana.png",
  Falconidae: "Falco.png",
  Phasianidae: "Gallus.png",
  Numididae: "Numida.png",
  Meleagrididae: "Meleagris.png",
  Pavonidae: "Pavo.png",
  Cracidae: "Ortalis.png",
  Rallidae: "Porphyrio.png",
  Gruidae: "Grus.png",
  Aramidae: "Aramus.png",
  Nyctibiidae: "Nyctibius.png",
  Opisthocomidae: "Opisthocomus.png",
  Bombycillidae: "Bombycilla.png",
  Cardinalidae: "Cardinalis.png",
  Certhiidae: "Certhia.png",
  Cinclidae: "Cinclus.png",
  Corvidae: "Cyanocitta.png",
  Cotingidae: "Procnias.png",
  Emberizidae: "Zonotrichia.png",
  Fringillidae: "Euphonia.png",
  Furnariidae: "Dendroplex.png",
  Hirundinidae: "Hirundo.png",
  Icteridae: "Icterus.png",
  Mimidae: "Mimus.png",
  Paridae: "Poecile.png",
  Parulidae: "Parula.png",
  Passerellidae: "Spizella.png",
  Passeridae: "Passer.png",
  Mephitidae: "Mephitis.png",
  Pipridae: "Chiroxiphia.png",
  Polioptilidae: "Polioptila.png",
  Regulidae: "Regulus.png",
  Sittidae: "Sitta.png",
  Sturnidae: "Sturnus.png",
  Thamnophilidae: "Thamnophilus.png",
  Thraupidae: "Thraupis.png",
  Tityridae: "Tityra.png",
  Troglodytidae: "Troglodytes.png",
  Turdidae: "Turdus.png",
  Tyrannidae: "Pitangus.png",
  Vireonidae: "Vireo.png",
  Ardeidae: "Ardea.png",
  Threskiornithidae: "Phimosus.png",
  Pelecanidae: "Pelecanus.png",
  Phaethontidae: "Phaethon.png",
  Phoenicopteridae: "Phoenicopterus.png",
  Podicipedidae: "Podilymbus.png",
  Diomedeidae: "Phoebastria.png",
  Elanidae: "Elanus.png",
  Procellariidae: "Puffinus.png",
  Psittacidae: "Amazona.png",
  Steatornithidae: "Steatornis.png",
  Strigidae: "Asio.png",
  Anhingidae: "Anhinga.png",
  Fregatidae: "Fregata.png",
  Phalacrocoracidae: "Nannopterum.png",
  Sulidae: "Sula.png",
  Trogonidae: "Trogon.png",
  Cyprinidae: "Cyprinus.png",
  Acanthuridae: "Paracanthurus.png",
  Muraenidae: "Uropterygius.png",
  Phyllomedusidae: "Agalychnis.png",
  Bufonidae: "Anaxyrus.png",
  Centroleninae: "Centrolene.png",
  Craugastoridae: "Craugastor.png",
  Dendrobatidae: "Dendrobates.png",
  Ranidae: "Lithobates.png",
  Hominidae: "Homo.png",
  Aotidae: "Aotus.png",
  Atelidae: "Alouatta.png",
  Callitrichidae: "Saguinus.png",
  Hylidae: "Hyla.png",
  Cebidae: "Cebus.png",
  Bovidae: "Bos.png",
  Canidae: "Canis.png",
  Felidae: "Leopardus.png",
  Mustelidae: "Lontra.png",
  Procyonidae: "Nasua.png",
  Delphinidae: "Tursiops.png",
  Ursidae: "Ursus.png",
  Phyllostomidae: "Artibeus.png",
  Molossidae: "Molossus.png",
  Rhincodontidae: "Rhincodon.png",
  Dasypodidae: "Dasypus.png",
  Didelphidae: "Didelphis.png",
  Leporidae: "Sylvilagus.png",
  Bradypodidae: "Bradypus.png",
  Otariidae: "Zalophus.png",
  Phocidae: "Phoca.png",
  Castoridae: "Castor.png",
  Caviidae: "Hydrochoerus.png",
  Erethizontidae: "Erethizon.png",
  Cricetidae: "Oryzomys.png",
  Sciuridae: "Tamiasciurus.png",
  Alligatoridae: "Alligator.png",
  Crocodylidae: "Crocodylus.png",
  Boidae: "Boa.png",
  Colubridae: "Pantherophis.png",
  Viperidae: "Bothrops.png",
  Cervidae: "Cervus.png",
  Suidae: "Sus.png",
  Tayassuidae: "Dicotyles.png",
  Corytophanidae: "Basiliscus.png",
  Dactyloidae: "Anolis.png",
  Dipsadidae: "Philodryas.png",
  Gekkoninae: "Lepidodactylus.png",
  Phrynosomatidae: "Phrynosoma.png",
  Phyllodactylidae: "Phyllodactylus.png",
  Teiidae: "Cnemidophorus.png",
  Tropiduridae: "Stenocercus.png",
  Chelonidae: "Chelonia.png",
  Emydidae: "Chrysemys.png",
  Podocnemididae: "Podocnemis.png",
  Testudinidae: "Chelonoidis.png",
  Araneidae: "Argiope.png",
  Theraphosidae: "Sphaerobothria.png",
  Buthidae: "Centruroides.png",
  Scolopendridae: "Scolopendra.png",
  Scutigeridae: "Scutigera.png",
  Blaberidae: "Archimandrita.png",
  Carabidae: "Pseudoxychelia.png",
  Cicadidae: "Neotibicen.png",
  Cerambycidae: "Callipogon.png",
  Scarabaeidae: "Dynastes.png",
  Coreidae: "Bitta.png",
  Pentatomidae: "Chinavia.png",
  Apidae: "Apis.png",
  Rhinocryptidae: "Scytalopus.png",
  Achatinidae: "Lissachatina.png",
  Formicidae: "Camponotus.png",
  Vespidae: "Polistes.png",
  Erebidae: "Cyanopepla.png",
  Hesperiidae: "Cymaenes.png",
  Lycaenidae: "Eumaeus.png",
  Nymphalidae: "Diaethria.png",
  Papilionidae: "Papilio.png",
  Pieridae: "Leptophobia.png",
  Riodinidae: "Cyrenia.png",
  Saturniidae: "Rothschildia.png",
  Uraniidae: "Urania.png",
  Mantidae: "Choeradodis.png",
  Eumastacidae: "Paramastax.png",
  Romaleidae: "Brachystola.png",
  Ocypodidae: "Ocypode.png",
  Grapsidae: "Grapsus.png",
  Coenobitidae: "Coenobita.png",
  Libellulidae: "Libellula.png",
  Chitonidae: "Chiton.png",
  Pelagiidae: "Chrysaora.png",
  Diadematidae: "Diadema.png",
  Asteriidae: "Pisaster.png",
  Ginkgoaceae: "Ginkgo.png",
  Phallaceae: "Phallus.png",
  Selaginellaceae: "Selaginella.png",
  Araliaceae: "Schefflera.png",
  Apiaceae: "Foeniculum.png",
  Asteraceae: "Tithonia.png",
  Aquifoliaceae: "Ilex.png",
  Boraginaceae: "Cordia.png",
  Caricaceae: "Carica.png",
  Cleomaceae: "Cleome.png",
  Amaranthaceae: "Celosia.png",
  Cactaceae: "Opuntia.png",
  Droseraceae: "Drosera.png",
  Nepenthaceae: "Nepenthes.png",
  Petiveriaceae: "Petiveria.png",
  Celastraceae: "Parnassia.png",
  Ericaceae: "Gaultheria.png",
  Sapindaceae: "Acer.png",
  Sapotaceae: "Pouteria.png",
  Fabaceae: "Leucaena.png",
  Fagaceae: "Fagus.png",
  Apocynaceae: "Asclepias.png",
  Gentianaceae: "Voyria.png",
  Rubiaceae: "Psychotria.png",
  Acanthaceae: "Thunbergia.png",
  Bignoniaceae: "Tabebuia.png",
  Lamiaceae: "Lavandula.png",
  Lentibulariaceae: "Pinguicula.png",
  Oleaceae: "Fraxinus.png",
  Verbenaceae: "Stachytarpheta.png",
  Lauraceae: "Ocotea.png",
  Magnoliaceae: "Magnolia.png",
  Clusiaceae: "Clusia.png",
  Euphorbiaceae: "Euphorbia.png",
  Malpighiaceae: "Bunchosia.png",
  Salicaceae: "Pleuranthodendron.png",
  Bixaceae: "Bixa.png",
  Malvaceae: "Malvaviscus.png",
  Lythraceae: "Cuphea.png",
  Melastomataceae: "Tibouchina.png",
  Vochysiaceae: "Vochysia.png",
  Aristolochiaceae: "Aristolochia.png",
  Piperaceae: "Piper.png",
  Platanaceae: "Platanus.png",
  Papaveraceae: "Bocconia.png",
  Cannabaceae: "Trema.png",
  Moraceae: "Ficus.png",
  Rhamnaceae: "Frangula.png",
  Rosaceae: "Fragaria.png",
  Urticaceae: "Cecropia.png",
  Aceraceae: "Acer.png",
  Anacardiaceae: "Toxicodendron.png",
  Burseraceae: "Bursera.png",
  Meliaceae: "Guarea.png",
  Rutaceae: "Citrus.png",
  Altingiaceae: "Liquidambar.png",
  Solanaceae: "Solanum.png",
  Vitaceae: "Parthenocissus.png",
  Myrtaceae: "Psidium.png",
  Araceae: "Anthurium.png",
  Arecaceae: "Bismarckia.png",
  Asparagaceae: "Asparagus.png",
  Asphodelaceae: "Aloe.png",
  Iridaceae: "Tigridia.png",
  Commelinaceae: "Tradescantia.png",
  Dioscoreaceae: "Dioscorea.png",
  Poaceae: "Saccharum.png",
  Bromeliaceae: "Ananas.png",
  Costaceae: "Costus.png",
  Heliconiaceae: "Heliconia.png",
  Marantaceae: "Calathea.png",
  Musaceae: "Musa.png",
  Strelitziaceae: "Strelitzia.png",
  Zingiberaceae: "Zingiber.png",
  Jungermanniaceae: "Jungermannia.png",
  Cupressaceae: "Cupressus.png",
  Pinaceae: "Pinus.png",
  Podocarpaceae: "Retrophyllum.png",
  Cycadaceae: "Cycas.png",
  Zamiaceae: "Dioon.png",
  Equisetaceae: "Equisetum.png",
  Nephrolepidaceae: "Nephrolepis.png",
  Arthoniaceae: "Cryptothecia.png",
  Cladoniaceae: "Cladonia.png",
  Pucciniaceae: "Hemileia.png",
  Agaricaceae: "Morganella.png",
  Hymenogastraceae: "Psilocybe.png",
  Polyporaceae: "Trametes.png",
  Russulaceae: "Lactarius.png",
  Tinamidae: "Tinamus.png",
  Odontophoridae: "Odontophorus.png",
  Grallariidae: "Grallaria.png",
  Mitrospingidae: "Mitrospingus.png",
  Dermophiidae: "Gymnopis.png",
  Plethodontidae: "Bolitoglossa.png",
  Scincidae: "Scincella.png",
  Anolidae: "Anolis.png",
  Gekkonidae: "Lepidodactylus.png",
  Sphaerodactylidae: "Gonatodes.png",
  Orchidaceae: "Cyrtochilum.png",
};

function FamilyPage() {
  useScrollMemory();

  const { kingdomName, phylumName, className, orderName, uid } = useParams();

  const location = useLocation();

  const currentUID = auth.currentUser?.uid;
  const dataUID = uid || currentUID;
  const families = familiesByOrder[orderName] || [];

  const adminModeActive =
    !!uid && new URLSearchParams(location.search).get("adminMode") === "true";

  const adminModeSuffix = adminModeActive ? "?adminMode=true" : "";

  const [speciesCounts, setSpeciesCounts] = useState({});
  const [countsLoading, setCountsLoading] = useState(true);

  const [browseMode, setBrowseMode] = useState("taxonomy");
  useEffect(() => {
    async function fetchSpeciesCounts() {
      setCountsLoading(true);

      const snapshot = await getDocs(
        collection(db, "users", dataUID, "species"),
      );

      const counts = {};

      snapshot.forEach((doc) => {
        const data = doc.data();
        const genus = data?.genus;
        if (!genus) return;

        const familyKey = Object.keys(generaByFamily).find((fam) =>
          generaByFamily[fam].includes(genus),
        );

        if (!familyKey) return;

        const key = familyKey.toLowerCase();
        counts[key] = (counts[key] || 0) + 1;
      });

      setSpeciesCounts(counts);
      setCountsLoading(false);
    }

    fetchSpeciesCounts();
  }, [dataUID]);

  const visibleItems = families.filter(
    (item) => Number(speciesCounts[item.toLowerCase()] || 0) > 0,
  );
  const totalSpecies = visibleItems.reduce(
    (sum, item) => sum + Number(speciesCounts[item.toLowerCase()] || 0),
    0,
  );
  const routePrefix = uid ? `/explore/${uid}` : "";

  return (
    <BioIndexExploreLevelLayout
      uid={uid}
      dataUID={dataUID}
      currentLevel="family"
      params={{ kingdomName, phylumName, className, orderName }}
      browseMode={browseMode}
      setBrowseMode={setBrowseMode}
      isOwnCollection={!uid || uid === currentUID}
      itemName="families"
      itemCount={visibleItems.length}
      secondaryCount={totalSpecies}
      adminModeActive={adminModeActive}
    >
      {countsLoading ? (
        <div className="bioindex-explore-empty" role="status">
          <span className="bioindex-explore-spinner" aria-hidden="true" />
          <h2>Loading families</h2>
        </div>
      ) : visibleItems.length === 0 ? (
        <div className="bioindex-explore-empty">
          <h2>No families to explore yet</h2>
          <p>There are no documented species in this group yet.</p>
        </div>
      ) : (
        <div className="bioindex-explore-kingdom-grid">
          {visibleItems.map((item) => {
            const key = item.toLowerCase();
            const count = Number(speciesCounts[key] || 0);
            const path = `/kingdom/${kingdomName}/phylum/${phylumName}/class/${className}/order/${orderName}/family/${key}`;
            const to = uid ? `${routePrefix}${path}${adminModeSuffix}` : path;
            return (
              <BioIndexTaxonCard
                key={item}
                name={item}
                count={count}
                image={getFamilyImage(item)}
                to={to}
                level="family"
                italic={false}
              />
            );
          })}
        </div>
      )}
    </BioIndexExploreLevelLayout>
  );
}

export default FamilyPage;
